<template>
    <div>
        <vs-input class="primary w-full" :placeholder="$t('etaExample')" v-model="etaValue" />
    </div>
</template>

<script>
    export default {
        props : {
            initialEta : {
                type : String,
                required : false,
            }
        },

        data () {
            return {
                etaValue : ''
            }
        },

        watch :{
            initialEta (val) {
                this.etaValue = val
            },
            etaValue (val) {
                this.$emit('change', val)
            }
        },

        mounted () {
            this.etaValue = this.initialEta
        }
    }
</script>